import styled from 'styled-components'

const H1 = styled.h1`
font-weight: 500;
  font-size: 42px;
  line-height: 49px;  
`

export default H1